// extracted by extract-css-chunks-webpack-plugin
module.exports = {"addToCartWrapper":"_95Ymg","customAddToCart":"_8kicO"};